import clsx from 'clsx'
import React from 'react'
import NumberFormat from 'react-number-format'

interface InputProps {
  value: number | any
  onChange: (e: any) => void
  isAllowed?: any
  suffix?: string
  name: string
  disabled: boolean
  showWarning?: boolean
}

interface Props {
  label: string
  value: number | any
  onChange: (e: any) => void
  input?: InputProps
  checked: boolean
  disabled?: boolean
  children?: React.ReactNode
}

export const DiscountInput: React.FC<Props> = ({label, input, children, ...props}) => {
  const handleChange = (e: any) => {
    if (input) {
      const {value} = e.target
      input.onChange(value)
    }
  }

  return (
    <div className='w-100 ms-6 me-6 pt-3 '>
      <label className='form-label fs-6 ms-11 fw-bold text-muted'>{label}</label>
      <span className='d-flex align-items-center gap-4'>
        <input
          name='discountType'
          type='radio'
          className='form-check-input min-w-23px'
          {...props}
        />
        {input && (
          <NumberFormat
            {...input}
            value={input.value ?? ''}
            className={clsx('ms-4 form-control min-w-100px bg-white', input.showWarning && 'is-invalid')}
            allowNegative={false}
            decimalScale={2}
            onChange={handleChange}
          />
        )}
        {children}
      </span>
    </div>
  )
}

export default DiscountInput
